/** Conversation empty state (06 S8) — desktop right-pane placeholder. */
import { Lock, MessageCircle } from 'lucide-react';
import styles from './EmptyState.module.css';

export function EmptyState() {
  return (
    <div className={styles.empty}>
      <div className={styles.lockup}>
        <span className={styles.logo}>
          <MessageCircle size={56} strokeWidth={1.4} />
        </span>
        <h1 className={styles.title}>Sinyal for Web</h1>
        <p className={styles.subtitle}>
          Select a chat to start messaging. Send and receive messages without
          keeping your phone online.
        </p>
      </div>
      <p className={styles.encryption}>
        <Lock size={13} aria-hidden="true" /> Your personal messages are
        end-to-end encrypted
      </p>
    </div>
  );
}
